module.exports = __webpack_public_path__ + "static/img/banner8.97d89ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner8.jpg
// module id = FLAE
// module chunks = 6